import React from "react";
import ComponentSpinner from "../@vuexy/spinner/Loading-spinner";

function LoaderComponent({ isLoading }) {
  return (
    <div className={`${!isLoading && "d-none"}`}>
      <ComponentSpinner color="primary" />
    </div>
  );
}

export default LoaderComponent;
